import React from "react";
import classNames from "classnames";
import { AccountTier } from "@bundles/consts";

interface TierBadgeProps {
  tier: AccountTier;
  isSmall?: boolean;
}

const tierStyles: Record<AccountTier, React.CSSProperties> = {
  [AccountTier.Tier_0]: { backgroundColor: "#CACACA" },
  [AccountTier.Tier_0_KYC]: { backgroundColor: "#CACACA" },
  [AccountTier.Tier_1_UK_restricted]: {
    backgroundImage: "linear-gradient(to right, #D66D56, #F79668, #D16C61)",
  },
  [AccountTier.Tier_1]: {
    backgroundImage: "linear-gradient(to right, #D66D56, #F79668, #D16C61)",
  },
  [AccountTier.Tier_2]: {
    backgroundImage: "linear-gradient(to right, #A8BACB, #B9C8D9, #A2B0C1)",
  },
  [AccountTier.Tier_3]: { backgroundColor: "#CACACA" },
  [AccountTier.Tier_4]: {
    backgroundImage: "linear-gradient(to right, #F5A833, #FFB444, #F7AA35)",
  },
};

export const tierLabels: Record<AccountTier, string> = {
  [AccountTier.Tier_0]: "Tier 0",
  [AccountTier.Tier_0_KYC]: "Tier 0",
  [AccountTier.Tier_1_UK_restricted]: "Tier 1",
  [AccountTier.Tier_1]: "Tier 1",
  [AccountTier.Tier_2]: "Tier 2",
  [AccountTier.Tier_3]: "Tier 3",
  [AccountTier.Tier_4]: "Tier 4",
};

export const TierBadge: React.FC<TierBadgeProps> = ({ tier, isSmall }) => {
  return (
    <div className="tailwind">
      <div
        className={classNames(
          "text-white rounded-full rounded-[30px] uppercase",
          {
            "text-[11px] py-[3px] px-[6px] leading-6": isSmall,
            "text-xs py-2 px-4": !isSmall,
          }
        )}
        style={tierStyles[tier]}
      >
        {tierLabels[tier]}
      </div>
    </div>
  );
};
